<template>
    <question-slide :slide="slide" :index="index" :addopinion="addopinion" :project="project" :parentslug="project.slug"></question-slide>
</template>

<script>

import dataStore from "../../store";
import QuestionSlide from "./../item-components/QuestionSlide";

export default {

    data() {
        return {
            dataStore,
        };
    },

    props: {
        slide : Object,
        project : Object,
        addopinion: Boolean,
        index : Number,
    },

    components: {
        QuestionSlide
    }

};
</script>

